module.exports = __webpack_public_path__ + "static/media/audio.a903d8fc.png";